<template>
    <div style="display: inline-block; width: 100%">
      <!-- 内部新增搜索框的策略 -->
        <el-select v-model="value" placeholder="请选择" multiple filterable clearable size="mini" @change="handleChange" :placeholder="inputPlaceholder" v-bind="$attrs" style="width: 100%;">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" ></el-option>
        </el-select>
    </div>
  </template>
  
  <script>
  import { getUserTree } from "@/api/basicApi.js";
  
  export default {
    name:'UserNotree',
    data() {
      return {
        options: [],
        value: [],
      };
    },
    props: {
      inputPlaceholder: {
        type: String,
        default: "请选择用户"
      },
      doClear: {
        type: Boolean,
        default: false
      }
    },
    watch: {
      doClear(newVal, oldVal) {
        this.clearSelect();
      }
    },
    methods: {
      handleChange(data) {
        this.$emit('change', data);
      },
      handleCheckChange(data) {
        console.log(data);
      },
      async initData() {
        const res = await getUserTree();
        this.options = res.data.flatMap(e => 
          e.childList ? e.childList.map(e2 => ({
            value: Number(e2.id),
            label: e2.trueName || e2.userName
          })) : []
        );
      },
      clearSelect() {
        this.value = '';
      }
      // monitoring() {
      //   // 监听事件
      //   this.$on("clearSelect", res => {
      //     this.$refs.userNameTree.setCheckedNodes([]);
      //   });
      // },
    },
    mounted() {
      this.initData();
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .is-reverse {
    transform: rotate(-180deg);
  }
  
  .selectClass {
    width: 100%;
  
    :deep(.el-input__inner) {
      height: 32px;
    }
  }
  
  .scrollbar-wrapper {
    background-color: #ffffff;
    max-height: 250px;
    overflow: auto;
    padding-right: 10px;
    margin-bottom: 10px;
    // .el-scrollbar__wrap {
    //   margin-bottom: -30px !important;
    // }
  }
  </style>
  <style lang="scss">
  </style>
  